import { render, staticRenderFns } from "./OrderInfoPackaging.vue?vue&type=template&id=3219a8ed&"
import script from "./OrderInfoPackaging.vue?vue&type=script&lang=js&"
export * from "./OrderInfoPackaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports